import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Añadir marca de agua
 * @param pdf
 * @param imgData
 */
const addWatermark = (pdf: jsPDF, imgData: string) => {
  const pageCount = pdf.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);

    // Puedes ajustar tamaño y posición aquí
    const width = 150;
    const height = 45;
    const x = (pdf.internal.pageSize.getWidth() - width) / 2;
    const y = (pdf.internal.pageSize.getHeight() - height) / 2;

    pdf.addImage(imgData, "PNG", x, y, width, height, "", "NONE", 0.1); // 0.1 = opacidad
  }
};

/**
 * Pasar una imagen a base64
 * @param url
 * @returns
 */
const getBase64Image = (url: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      if (ctx?.globalAlpha) {
        ctx.globalAlpha = 0.05;
      }
      ctx?.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL("image/png");
      resolve(dataURL);
    };
    img.onerror = (err) => reject(err);
  });
};

export const exportToPdf = async (
  title: string,
  subtitle: string,
  namePDF: string,
  ids: string[]
): Promise<void> => {
  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // // Título en la primera página
  pdf.setFontSize(13);
  pdf.text(`${title}`, pageWidth / 2, 10, {
    align: "center",
  });
  pdf.text(`${subtitle}`, pageWidth / 2, 19, {
    align: "center",
  });

  // Controla el alto ya ocupado (por título, etc.)
  let currentY = 30; // después del título (ajusta si es necesario)

  for (let i = 0; i < ids.length; i++) {
    const element = document.getElementById(ids[i]);
    if (!element) continue;

    const canvas = await html2canvas(element, { scale: 1, useCORS: true });
    const imgData = canvas.toDataURL("image/png", 0.6);

    const imgProps = {
      width: pageWidth - 20,
      height: (canvas.height * (pageWidth - 20)) / canvas.width,
    };

    // 🧠 Espacio que queda en la página actual
    const spaceLeft = pageHeight - currentY - 10; // 10 = margen inferior

    if (imgProps.height <= spaceLeft) {
      // Cabe en la página actual
      pdf.addImage(imgData, "PNG", 10, currentY, imgProps.width, imgProps.height);
      currentY += imgProps.height + 10;
    } else if (imgProps.height <= pageHeight - 20) {
      // No cabe, pero sí cabe en una nueva página entera
      pdf.addPage();
      currentY = 10;
      pdf.addImage(imgData, "PNG", 10, currentY, imgProps.width, imgProps.height);
      currentY += imgProps.height + 10;
    } else {
      // Imagen muy larga → partir en varias páginas
      let position = 0;
      let heightLeft = imgProps.height;

      while (heightLeft > 0) {
        pdf.addPage();
        const y = 10;
        pdf.addImage(imgData, "PNG", 10, y, imgProps.width, imgProps.height);
        heightLeft -= pageHeight;
        position -= pageHeight;
      }
      currentY = pageHeight + 1; // obliga siguiente a ir a nueva página si queda más contenido
    }
  }

  const watermarkBase64 = (await getBase64Image("/img/aquacorp_logo.png")) as string;
  addWatermark(pdf, watermarkBase64);
  pdf.save(`${namePDF}`);
};
